import { Component } from 'js-component-framework';

/**
 * Component for instantiating Site Header Search
 */
export default class SiteSearch extends Component {

  /**
   * Start the component
   */
  constructor(config) {
    super(config);

    // Elements
    this.page = document.getElementById('page');
    this.trigger = document.querySelector('.site-nav__search-trigger');

    // Initalizations
    this.triggerShowSearch();
    this.triggerHideSearch();
  }

  /**
   * Trigger to show search field
   */
  triggerShowSearch() {
    this.trigger.addEventListener('click', () => {
      this.page.classList.add(this.options.overlayActiveClass);
      this.element.classList.add(this.options.searchActiveClass);
      this.children.searchField.focus();
    });
  }

  /**
   * Trigger to hide search field
   */
  triggerHideSearch() {
    this.children.close.addEventListener('click', () => {
      this.page.classList.remove(this.options.overlayActiveClass);
      this.element.classList.remove(this.options.searchActiveClass);
      this.children.searchField.blur();
    });
  }
}



// WEBPACK FOOTER //
// ./client/js/components/SiteSearch/SiteSearch.js